export const mutations = {

  setInv: function (state, inv) {
    state.inv = inv;
  },


  setFeeList: function (state, doc) {
    state.feeList = doc;
  },

  setDocChecklist: function (state, doc) {
    state.docCheckList = doc;
  },

  setDocAttached: function (state, doc) {
    state.docAttached = doc;
  },
  
  setSelectedFee: function (state, data) {
    state.selected_fee = [data];
  },

  setEntreatyProc: function (state, ent) {
    var data = [...(ent ?? [])].reverse();
    var hasNoti = [...state.noti_process].map((e) => e.ent_id);
    var temp = data.map((e) => {
      e['has_noti'] = false;
      if(hasNoti.includes(e.ent_id)){
        e['has_noti'] = true;
        e['noti_id'] = [...state.noti_process].find((i) => i.ent_id == e.ent_id).noti_id;
      }
      return e;
    });
    state.ent_proc = temp;
  },

  setEntreatyPaym: function (state, ent) {
    state.ent_paym = ent;
  },

  setEntreatyDone: function (state, ent) {

    var tmp = [...ent].map((d) => {
      d.CreatedAt = new Date(d.CreatedAt.substring(0,10));
      d.ApproveDate = new Date(d.ApproveDate.substring(0,10));
      d.ExpireDate = new Date(d.ExpireDate.substring(0,10));
      return d;
    });
    state.ent_done = tmp;
   
  },

  setEntreatyDetail: function (state, detail) {
    state.ent_detail = detail;
  },

  setDocTemplate: function (state, doc) {
    state.ent_doc_template = doc;
  },

  setApplication: function (state, application) {
    state.ent_has_application = true;
    state.ent_application.ent_id = application.ent_id;
    state.ent_application.created_at = application.created_at;
    state.ent_application.first_name = application.first_name;
    state.ent_application.surname = application.surname;
    state.ent_application.birthdate = application.birthdate;
    state.ent_application.address_id = application.address_id;
    state.ent_application.village = application.village;
    state.ent_application.district = application.district;
    state.ent_application.province = application.province;
    state.ent_application.nationality = application.nationality;
    state.ent_application.personal_no = application.personal_no;
    state.ent_application.passport_no = application.passport_no;
    state.ent_application.gender = application.gender;
    state.ent_application.office_name_la = application.office_name_la;
    state.ent_application.office_name_en = application.office_name_en;
    state.ent_application.business_type = application.business_type;
  },

  setAttorney: function (state, attorney) {
    state.ent_has_attorney = true;
    state.ent_attorney.ent_id = attorney.ent_id;
    state.ent_attorney.version_no = attorney.version_no;
    state.ent_attorney.created_at = attorney.created_at;
    state.ent_attorney.g_first_name = attorney.g_first_name;
    state.ent_attorney.g_surname = attorney.g_surname;
    state.ent_attorney.g_age = attorney.g_age;
    state.ent_attorney.g_work = attorney.g_work;
    state.ent_attorney.g_position = attorney.g_position;
    state.ent_attorney.g_duty = attorney.g_duty;
    state.ent_attorney.g_home_no = attorney.g_home_no;
    state.ent_attorney.g_group_no = attorney.g_group_no;
    state.ent_attorney.g_address_id = attorney.g_address_id;
    state.ent_attorney.g_village = attorney.g_village;
    state.ent_attorney.g_district = attorney.g_district;
    state.ent_attorney.g_province = attorney.g_province;
    state.ent_attorney.g_credit_type = attorney.g_credit_type;
    state.ent_attorney.g_credit_no = attorney.g_credit_no;
    state.ent_attorney.g_credit_start = attorney.g_credit_start;
    state.ent_attorney.g_credit_end = attorney.g_credit_end;
    state.ent_attorney.g_credit_by = attorney.g_credit_by;
    state.ent_attorney.g_place = attorney.g_place;
    state.ent_attorney.g_tell = attorney.g_tell;
    state.ent_attorney.g_email = attorney.g_email;
    state.ent_attorney.r_first_name = attorney.r_first_name;
    state.ent_attorney.r_surname = attorney.r_surname;
    state.ent_attorney.r_age = attorney.r_age;
    state.ent_attorney.r_work = attorney.r_work;
    state.ent_attorney.r_position = attorney.r_position;
    state.ent_attorney.r_duty = attorney.r_duty;
    state.ent_attorney.r_home_no = attorney.r_home_no;
    state.ent_attorney.r_group_no = attorney.r_group_no;
    state.ent_attorney.r_address_id = attorney.r_address_id;
    state.ent_attorney.r_village = attorney.r_village;
    state.ent_attorney.r_district = attorney.r_district;
    state.ent_attorney.r_province = attorney.r_province;
    state.ent_attorney.r_credit_type = attorney.r_credit_type;
    state.ent_attorney.r_credit_no = attorney.r_credit_no;
    state.ent_attorney.r_credit_start = attorney.r_credit_start;
    state.ent_attorney.r_credit_end = attorney.r_credit_end;
    state.ent_attorney.r_credit_by = attorney.r_credit_by;
    state.ent_attorney.r_tell = attorney.r_tell;
    state.ent_attorney.r_email = attorney.r_email;
  },

  setEntreatyTimeline: function (state, timeline) {
    state.ent_timeline = timeline;
  },

  setDocument: function (state, res) {
    state.ent_document = res;
  },

  setCategory: function (state, data) {
    console.log(data);
    state.selected_cate.push(data);
    const cate_id_temp = [...state.selected_cate].filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) =>
            t.cate_id === value.cate_id &&
            t.cate_type === value.cate_type &&
            t.cate_type_parent_id === value.cate_type_parent_id
        )
    );

    state.selected_cate = cate_id_temp;
    state.entreaty.categories = [
      ...state.selected_cate_parent,
      ...cate_id_temp,
    ];
    // console.log(state.entreaty.categories);
  },

  setCategoryParent: function (state, data) {
    state.selected_cate_parent = data;
    const cate_id_temp = [...state.selected_cate_parent].filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) =>
            t.cate_id === value.cate_id &&
            t.cate_type === value.cate_type &&
            t.cate_type_parent_id === value.cate_type_parent_id
        )
    );

    state.selected_cate_parent = cate_id_temp;
    state.entreaty.categories = [...state.selected_cate, ...data];
    // console.log(state.entreaty.categories);
  },

  updateCatetagoty: function (state, { temp, tempParent }) {
    state.selected_cate = temp;
    const cate_id_temp = [...state.selected_cate_parent].filter(
      (el) => [...tempParent].findIndex((e) => e.cate_id === el.cate_id) < 0
    );

    state.selected_cate_parent = cate_id_temp;
    state.entreaty.categories = [...cate_id_temp, ...temp];
    // console.log(state.entreaty.categories);
  },

  updateAction: function (state, data) {
    state.entreaty.action = data;
    state.entreaty.action_code = data.action_code;
    state.entreaty.action_type = data.action_type;
  },

  updateMaker: function (state, data) {
    state.entreaty.maker = data;
  },

  setEntFind: function (state, data) {
    state.ent_find = data;
  },

  setEformApplication: function (state, data) {
    state.eform_application = data;
  },

  setNotification: function(state, data) {
    var menuDone = [];
    var menuProcess = [];
    var menuWaitingPay = [];
    [...data].forEach((e) => {
      if(e.to_status_code == "PAID_TXN" || e.to_status_code == "PAID_CASH" || e.to_status_code == "DELIVER") {
        menuDone.push(e);
      } else if (e.to_status_code == "DOC_SUBMIT" || e.to_status_code == "DOC_VERIFY" || e.to_status_code == "REJECT" || e.to_status_code == "REQUEST_ONSITE" || e.to_status_code == "WAITING_APPROVAL") {
        menuProcess.push(e);
      } else if (e.to_status_code == "APPROVAL_ACCEPT" || e.to_status_code == "TXN_WAITING") {
        menuWaitingPay.push(e);
      }
    })

    state.noti_process = menuProcess;
    state.noti_waiting = menuWaitingPay;
    state.noti_history = menuDone;
    
    state.nav_menu[1].counter = menuProcess.length;
    state.nav_menu[1].hasNoti = menuProcess.length > 0

    state.nav_menu[2].counter = menuWaitingPay.length;
    state.nav_menu[2].hasNoti = menuWaitingPay.length > 0

    state.nav_menu[3].counter = menuDone.length;
    state.nav_menu[3].hasNoti = menuDone.length > 0
  }
};
